import { render, staticRenderFns } from "./uni-load-more.vue?vue&type=template&id=396711e2&scoped=true&"
import script from "./uni-load-more.vue?vue&type=script&lang=js&"
export * from "./uni-load-more.vue?vue&type=script&lang=js&"
import style0 from "./uni-load-more.vue?vue&type=style&index=0&id=396711e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396711e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396711e2')) {
      api.createRecord('396711e2', component.options)
    } else {
      api.reload('396711e2', component.options)
    }
    module.hot.accept("./uni-load-more.vue?vue&type=template&id=396711e2&scoped=true&", function () {
      api.rerender('396711e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uni-load-more/uni-load-more.vue"
export default component.exports